/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetBitcoinHoldingsRewardSummaryRequest} from '@cash-web/protos/squareup/cash/cryptoinvestflow/service/bitcoin_holdings_reward.pb'
import {GetBitcoinHoldingsRewardSummaryResponse} from '@cash-web/protos/squareup/cash/cryptoinvestflow/service/bitcoin_holdings_reward.pb'


export const getBitcoinHoldingsRewardSummary = (request: GetBitcoinHoldingsRewardSummaryRequest, options?: CashRequestOptions) => post<GetBitcoinHoldingsRewardSummaryRequest, GetBitcoinHoldingsRewardSummaryResponse>("/2.0/cash/get-bitcoin-holdings-reward-summary", request, {...options, rejectOnError: true })